module.exports = __webpack_public_path__ + "img/person@2x.65202c09.png";